import React from 'react'
import '../css/header.css';

function Header() {

  const scrollToPrices = () => {
    const section = document.querySelector('.section-prices');
    if (section) {
      section.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <header className='header-home-top' >
        <div>
        <div className='container-logo'>
            <div className='profile-logo'></div>
            <h1 className='text-logo'>JGTC</h1>
            <li className='items-header-op' onClick={scrollToPrices}>Menbresías</li>
            <li className='items-header-op'>Proyectos</li>
            <li className='items-header-op'>Nosotros</li>
        </div>
        </div>


            <div>
            <a href="https://calendly.com/agenciajgtc" target="_blank" rel="noopener noreferrer">
                <button className='btn-op-header'>Agendar Llamado</button>
                </a>
            </div>


    </header>
  )
}

export default Header
